module.exports = __webpack_public_path__ + "img/web_active1.6894fd95.svg";